<template slot-scope="scope">
  <el-select
    :value="localValue"
    :disabled="disabledFlag"
    @input="$emit('input', $event)"
    placeholder="请选择学期"
    clearable style="width: 100%">
    <el-option v-for="item in items" :key="item.id" :label="item.leamTermName" :value="item.id"></el-option>
  </el-select>
</template>
<script>
  export default {
    props: {
      value: null,
      yearId: {
        type: String,
        default: '',
      },
     status: {
       type: Number,
       default: -1,
     },
      disabledFlag: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      value(val){
        this.localValue = val
      },
      yearId(){
        this.query();
      },
     status(){
       this.query();
     }
    },
    data() {
      return {
        localValue: this.value,
        items:[]
      }
    },
    methods: {
      query(){
        let vm = this
        if(vm.status == -1){
          if(!vm.yearId){
            http.get(InterfacePrefix['platform'] + "/api/leamTerm").then(function(xhr) {
//            if (xhr.data.code) return // 异常情况有公共处理
              vm.items = xhr.data
            })
          } else {
            http.get(InterfacePrefix['platform'] + "/api/leamTerm?yearId="+vm.yearId).then(function(xhr) {
//            if (xhr.data.code) return // 异常情况有公共处理
              vm.items = xhr.data
            })
          }
        } else {
          if(!vm.yearId){
            http.get(InterfacePrefix['platform'] + "/api/leamTerm?status="+vm.status).then(function(xhr) {
//            if (xhr.data.code) return // 异常情况有公共处理
              vm.items = xhr.data
            })
          } else {
            http.get(InterfacePrefix['platform'] + "/api/leamTerm?yearId="+vm.yearId+"&status="+vm.status).then(function(xhr) {
//            if (xhr.data.code) return // 异常情况有公共处理
              vm.items = xhr.data
            })
          }
        }
      }
    },
    mounted() {
      this.query()
    },
  }

</script>



// WEBPACK FOOTER //
// src/commonplugin/chose_param/chooseTerm.vue